import { nanpPostalCodePattern } from "@homeinstead/locale";
import { z } from "zod";

export const postalCode = z.string().regex(nanpPostalCodePattern, {
  error: "Postal code must be a valid US ZIP or Canadian postal code",
});
